import { useSelector } from 'react-redux'
import type { BuildingState } from './types'
import type { State } from '../types'

export const useBuilding = (): Partial<BuildingState> => {
  const { building, isInitialized, isLoading, hasError } = useSelector((state: State) => state.building)

  return { building, isInitialized, isLoading, hasError }
}
